import React from "react";

const NextIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="#F0F1FA" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#F0E4F8" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.6288 7.29289C13.0194 6.90237 13.6525 6.90237 14.043 7.29289L22.043 15.2929C22.4336 15.6834 22.4336 16.3166 22.043 16.7071L14.043 24.7071C13.6525 25.0976 13.0194 25.0976 12.6288 24.7071C12.2383 24.3166 12.2383 23.6834 12.6288 23.2929L19.9217 16L12.6288 8.70711C12.2383 8.31658 12.2383 7.68342 12.6288 7.29289Z"
        fill="#6E00BE"
      />
    </svg>
  );
};

export default NextIcon;
